import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';

const SearchButton = (props) => {

  const { t } = useTranslation();
  const { history } = props;

  return (
    <button
      className={styles.search}
      onClick={() => {
        history.push('/search');
      }}
    >
      {t('Search')}
    </button>
  );
};

export default SearchButton;
